<template>
  <div>
    <div class="field-container">
      <h5 v-if="title">{{ title }}</h5>
      <form-item-i-tooltip v-if="tooltip" placement="top-start">
        <template #content>
          <span> {{ tooltip }} </span>
        </template>
      </form-item-i-tooltip>
    </div>
    <p>{{ formattedMetric }}</p>
  </div>
</template>

<script>
import i18n from '@/core/utils/I18n'
import FormItemITooltip from '@/common/components/form/FormItemITooltip'
import { mapGetters } from 'vuex'

export default {
  name: 'Metric',
  components: { FormItemITooltip },
  props: {
    title: {
      type: String
    },
    metric: {
      type: [Number, String]
    },
    type: {
      type: String,
      required: false
    },
    tooltip: {
      type: String,
      required: false
    }
  },

  computed: {
    ...mapGetters(['projectTimezone']),

    formattedMetric() {
      // convert null values to '-'
      if (!this.metric && this.metric !== 0) {
        return '-'
      }

      // convert values to numbers and format them
      if (!isNaN(this.metric)) {
        return new Intl.NumberFormat(i18n.locale, this.formatOptions).format(
          this.formatValue
        )
      }

      if (this.type === 'datetime') {
        // set locale to en-GB to display the default date in dd/mm/yyyy format
        const locale = i18n.locale === 'en' ? 'en-GB' : i18n.locale
        return new Intl.DateTimeFormat(locale, this.formatOptions).format(
          this.formatValue
        )
      }

      // if above fails, return unformatted value
      return this.metric
    },

    formatOptions() {
      switch (this.type) {
        case 'datetime':
          return {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric',
            hour12: false,
            timeZone: this.projectTimezone
          }
        case 'percentage':
          return { style: 'percent', maximumFractionDigits: 2 }
        default:
          return {}
      }
    },

    formatValue() {
      switch (this.type) {
        case 'datetime':
          return new Date(this.metric)
        case 'percentage':
          return this.metric / 100
        default:
          return this.metric
      }
    }
  }
}
</script>

<style scoped>
h5 {
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 18px;
  color: #808080;
}

p {
  font-weight: 600;
  font-size: 24px;
  line-height: 30px;
  color: #333333;
}
.field-container {
  display: flex;
  align-items: center;
  margin-top: 6px;
}
</style>



// WEBPACK FOOTER //
// src/common/components/Metric.vue